module.exports = __webpack_public_path__ + "img/stock.8869220c.svg";